import axios from "axios";
import { useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../url/api";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const session_id = urlParams.get("session_id");

  const callPaymentSuccessApi = async () => {
    const response = await axios.get(
      `${API_URL}validate/checkout-status/${session_id}/`
    );
    console.log("Form submitted successfully:", response.data);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 3000);

    callPaymentSuccessApi();
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <div className="flex items-center justify-center mb-4">
          <FaCheckCircle className="text-6xl text-green-500" />
        </div>
        <h1 className="text-3xl font-bold mb-2 text-center">
          Payment Successful!
        </h1>
        <p className="text-gray-600 text-center">
          Thank you for your payment. You will be redirected to the dashboard
          shortly.
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
